import type { FC } from "react";
import { Stack, Text, Title } from "@mantine/core";
import { IconMessageCircle } from "@tabler/icons-react";
import {
  getAllOrderComments,
  getAllRedoComments,
  type Order,
} from "@jasper/shared";
import { OrderCommentsList } from "../OrderCommentsList";
import type { OrderPageState } from "../useOrderPage";
import { OrderDetailCard } from "./OrderDetailCard";

type OrderNotesCardProps = {
  order: Order;
  state: OrderPageState;
};

export const OrderNotesCard: FC<OrderNotesCardProps> = ({ order, state }) => {
  const commentsListProps = {
    orderComments: state.orderComments,
    getPresignedDownloadUrl: state.actions.getPresignedDownloadUrl,
  };
  const redoComments = getAllRedoComments(order);

  return (
    <OrderDetailCard
      icon={IconMessageCircle}
      iconColor="navy"
      title="Notes du praticien"
    >
      <Stack gap="s4">
        <OrderCommentsList
          comments={getAllOrderComments(order)}
          emptyLabel={<Text size="sm">Pas de note pour cette commande</Text>}
          {...commentsListProps}
        />
        {redoComments.length > 0 && (
          <Stack gap="s2">
            <Title order={5}>Demande de refabrication</Title>
            <OrderCommentsList comments={redoComments} {...commentsListProps} />
          </Stack>
        )}
      </Stack>
    </OrderDetailCard>
  );
};
